import React, { useContext } from "react";

import AttributeInputField from "../../../attributes/compare-table/attribute-input-field";

import { AttributesContext, AttributeGroupDataContext } from "../../../../contexts/attributes";

const RootField = ({ attribute, attributeList, defaultValue, Field, parentAttribute, readOnly, isGroup, updateOnChange, disabled }) => {
    const attributes = useContext(AttributesContext);
    const attributeGroup = useContext(AttributeGroupDataContext);

    const updateField = (attr, value) => {
        const groupValues = attributeList.reduce((obj, a) => {
            obj[a.uuid] = attr.uuid === a.uuid ? value : attributeGroup.data[a.uuid] || "";

            return obj;
        }, {});

        if (updateOnChange) {
            updateOnChange(parentAttribute.uuid, { ...groupValues }, attribute.componentType);
        } else if (parentAttribute.uuid) {
            attributes.update(parentAttribute, {
                ...groupValues,
            });
        }

        attributeGroup.updateMany({
            ...groupValues,
        });
    };

    return (
        <AttributeInputField
            id={`AGF_${attribute.uuid}`}
            name={`AGF_${attribute.uuid}`}
            Field={Field}
            attribute={attribute}
            defaultValue={defaultValue}
            disabled={readOnly || disabled}
            isGroup={isGroup}
            useAttributes={{
                data: attributeGroup.data,
                update: updateField,
            }}
        />
    );
};

export default RootField;
